//Development
// const app_id = '321131902035431';
// const firebase_project_id = 'chaty-boty';
// const app_url = 'https://chaty-boty.firebaseapp.com/dashboard';
// const firebaseconfig = {
//     apiKey: "AIzaSyDUFFqV-Y0QDadPlJzW5YppiMgg59PdzcI",
//     authDomain: "chaty-boty.firebaseapp.com",
//     databaseURL: "https://chaty-boty.firebaseio.com",
//     projectId: "chaty-boty",
//     storageBucket: "chaty-boty.appspot.com",
//     messagingSenderId: "753213076159"
// }

//Test
// const app_id = '2331491323561707';
// const firebase_project_id = 'nicechats-test';
// const app_url = 'https://nicechats-test.firebaseapp.com/dashboard';
// const firebaseconfig = {
//     apiKey: "AIzaSyAkha0jJJDg2f4ZdSq_mh1X5odtPYFtc58",
//     authDomain: "nicechats-test.firebaseapp.com",
//     databaseURL: "https://nicechats-test.firebaseio.com",
//     projectId: "nicechats-test",
//     storageBucket: "nicechats-test.appspot.com",
//     messagingSenderId: "571956701961"
// }

//Production
const app_id = '333020217350450';
const firebase_project_id = 'nicechats-prod';
//const app_url = 'https://nicechats-prod.firebaseapp.com/dashboard/';
const app_url = 'https://app.nicechat.in/dashboard/';
const firebaseconfig = {
    apiKey: "AIzaSyAUzYtAXjLTc4xbZ0jQ9N5MUwujVc6sccc",
    authDomain: "app.nicechat.in",
    databaseURL: "https://nicechats-prod.firebaseio.com",
    projectId: "nicechats-prod",
    storageBucket: "nicechats-prod.appspot.com",
    messagingSenderId: "383164019355"
}

export{
    app_id,
    firebase_project_id,
    app_url,
    firebaseconfig
}